import { Directive, ElementRef, HostListener, Inject } from '@angular/core';

@Directive({
  selector: '[selectOnClick]',
  standalone: false,
})
export class SelectOnClickDirective {
  constructor(@Inject(ElementRef) private el: ElementRef) {}

  @HostListener('click')
  onClick() {
    this.el.nativeElement.select();
  }
}
